export const HANDLE_SELECTHOME_FORM = 'HANDLE_SELECTHOME_FORM'
export const ADDRESS_VALID_FOR_HISOPADO = 'ADDRESS_VALID_FOR_HISOPADO' 
export const SET_ADDRESS_LAT_LONG_HISOPADO = 'SET_ADDRESS_LAT_LONG_HISOPADO'